<template>
  <div class="container-fluid">
    <dpa-account-form
      :loading="loading"
      :dpaAccountData="dpaAccount"
      :formErrors="formErrors"
      @dpaAccountSubmitted="handleSubmit"
      @formChanged="() => (alertLeave = true)"
    />
  </div>
</template>

<script>
import { Select, Option } from "element-ui";
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";
import defaultDpaAccount from "../defaultDpaAccount";
import DpaAccountForm from "../partials/DpaAccountForm.vue";

export default {
  layout: "DashboardLayout",

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    DpaAccountForm,
  },

  mixins: [alertLeave],

  data() {
    return {
      dpaAccount: cloneDeep(defaultDpaAccount),
      formErrors: null,
      loading: false,
    };
  },

  created() {},

  methods: {
    async handleSubmit(dpaAccount) {
      this.loading = true;

      const dpaAccountData = cloneDeep(dpaAccount);
      delete dpaAccountData.id;

      try {
        await this.$store.dispatch("dpaAccounts/add", dpaAccountData);
        this.$notify({
          type: "success",
          message: this.$t("DPA_PPA.DPA_TRANSACTION_ADDED"),
        });
        const dpaAccount = await this.$store.getters["dpaAccounts/dpaAccount"];
        this.$emit("onViewDpaAccount", dpaAccount, true);
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
  },
};
</script>
